<template>
  <div class="contact-page">
    <sub-banner>
      <template v-slot:text>
        <h1 class="fw-bold">Contact</h1>
      </template>
    </sub-banner>
    <div class="container-xxl py-5" style="margin-top: -100px">
      <div class="container">
        <div class="text-center mx-auto mb-5 wow fadeInUp" data-wow-delay="0.1s"
             style="max-width: 600px; visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
          <h1 class="display-5 mb-4 fw-bold">Kom in contact met FTM installatietechniek</h1>
        </div>
        <div class="row g-5">
          <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.1s"
               style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
            <a href="https://maps.app.goo.gl/8oGXxfA4Q4ieGKvq9" style="text-decoration: none" target="_blank">
              <div class="bg-light blokje d-flex align-items-center w-100 p-4 mb-4">
                <div class="d-flex flex-shrink-0 align-items-center justify-content-center bg-dark"
                     style="width: 55px; height: 55px;">
                  <i class="fa fa-map-marker-alt text-white"></i>
                </div>
                <div class="ms-4">
                  <p class="mb-2 fs-5" style="color: #212529">Adres</p>
                  <h3 class="mb-0 fs-4">Moerasstraat 7J, 8082 AJ Elburg</h3>
                </div>
              </div>
            </a>
            <a href="tel:0611103693" style="text-decoration: none" target="_blank">
              <div class="bg-light blokje d-flex align-items-center w-100 p-4 mb-4">
                <div class="d-flex flex-shrink-0 align-items-center justify-content-center bg-dark"
                     style="width: 55px; height: 55px;">
                  <i class="fa fa-phone-alt text-white"></i>
                </div>
                <div class="ms-4">
                  <p class="mb-2 fs-5" style="color: #212529">Bel ons</p>
                  <h3 class="mb-0 fs-4">+31 6 11103693</h3>
                </div>
              </div>
            </a>
            <a href="mailto:info@faber-tm.nl" style="text-decoration: none" target="_blank">
              <div class="bg-light blokje d-flex align-items-center w-100 p-4 mb-0">
                <div class="d-flex flex-shrink-0 align-items-center justify-content-center bg-dark"
                     style="width: 55px; height: 55px;">
                  <i class="fa fa-envelope-open text-white"></i>
                </div>
                <div class="ms-4">
                  <p class="mb-2 fs-5" style="color: #212529">Mail ons</p>
                  <h3 class="mb-0 fs-4">info@faber-tm.nl</h3>
                </div>
              </div>
            </a>
          </div>
          <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.5s"
               style="visibility: visible; animation-delay: 0.5s; animation-name: fadeInUp;">
            <div class="contact-form wow fadeInUp" data-wow-delay="0.2s"
                 style="visibility: visible; animation-delay: 0.2s; animation-name: fadeInUp;">
              <h2 class="fs-4 fw-bold">Vragen of een offerte aanvragen?</h2>
              <p class="fs-5">Of het nu gaat om een nieuwe installatie of onderhoud van bestaande systemen, wij bieden
                maatwerkoplossingen voor al je wensen. Neem vandaag nog contact met ons op voor advies of een
                vrijblijvende offerte. We staan klaar om je te helpen met duurzame en betrouwbare installaties!</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextImage from '@/components/TextImage.vue'
import SubBanner from "@/components/SubBanner";
import ListImage from "@/components/ListImage";

export default {
  name: "Contact",
  components: {
    SubBanner,
    TextImage,
    ListImage
  },
  created() {
    window.scrollTo(0, 0)
  },
  mounted() {
    window.scrollTo(0, 0);
  }
}
</script>

<style lang="scss" scoped>

$gold: #D6AD60;

.contact-title {
  @media (max-width: 700px) {
    font-size: 25px;
    line-height: 30px;
  }
}

.col-lg-6 {
  @media (max-width: 980px) {

    padding: 0 6px !important;
  }
}

.blokje {
  background-color: #ececec !important;
}

</style>
